import forEach from './_helpers/foreach.js';
import forOwn from './_helpers/forown.js';
import MatreshkaObject from './object/index.js';
import MatreshkaArray from './array/index.js';
export default function toMatreshka(data) {
  // convert only objects
  if (data && typeof data === 'object') {
    if (Array.isArray(data) || data.isMatreshkaArray) {
      // arrays become Matreshka.Array instances
      var arrayItems = Array(data.length);
      forEach(data, function (item, index) {
        arrayItems[index] = toMatreshka(item);
      });
      return new MatreshkaArray().recreate(arrayItems);
    }
    // other objects become Matreshka.Object instances
    var object = {};
    // of a Matreshka.Object take only data keys
    forOwn(data.isMatreshkaObject ? data.toJSON(false) : data, function (value, key) {
      object[key] = toMatreshka(value);
    });
    return new MatreshkaObject(object);
  }
  // for all non-objects just return passed data
  return data;
}